export function Features() {
  const features = [
    {
      icon: '🧠',
      title: 'Natural Language to SQL',
      description:
        'Advanced AI converts your plain English questions into optimized SQL queries with built-in guardrails.',
      benefits: [
        'No SQL knowledge required',
        'Context-aware queries',
        'Automatic optimization',
      ],
    },
    {
      icon: '📊',
      title: 'Auto-Charts & Summaries',
      description:
        'Get instant visualizations and key insights without manual chart creation or data manipulation.',
      benefits: [
        'Interactive dashboards',
        'Smart summaries',
        'Export-ready reports',
      ],
    },
    {
      icon: '🔒',
      title: 'Secure Database Access',
      description:
        'Read-only connections with enterprise-grade security ensure your data stays protected.',
      benefits: ['Read-only access', 'Role-based permissions', 'Audit trails'],
    },
    {
      icon: '👥',
      title: 'Team-Ready Dashboards',
      description:
        'Share insights across your organization with collaborative dashboards and scheduled reports.',
      benefits: [
        'Collaborative workspaces',
        'Scheduled reports',
        'Team sharing',
      ],
    },
  ];

  return (
    <section id="features" className="section-padding bg-white">
      <div className="container-wrapper">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Everything You Need for Data Insights
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            QueryZen provides a complete solution for business teams to access,
            analyze, and share data insights without technical barriers.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8">
              <div className="flex items-start space-x-4">
                <div className="text-4xl flex-shrink-0">{feature.icon}</div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 mb-4">{feature.description}</p>
                  <ul className="space-y-2">
                    {feature.benefits.map((benefit, benefitIndex) => (
                      <li
                        key={benefitIndex}
                        className="flex items-center text-sm text-gray-700"
                      >
                        <svg
                          className="w-4 h-4 text-primary-500 mr-2 flex-shrink-0"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/*<div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="bg-primary-50 rounded-lg p-6">
            <div className="text-3xl font-bold text-primary-600 mb-2">10x</div>
            <div className="text-gray-700">Faster Query Development</div>
          </div>
          <div className="bg-primary-50 rounded-lg p-6">
            <div className="text-3xl font-bold text-primary-600 mb-2">
              99.9%
            </div>
            <div className="text-gray-700">Uptime Guarantee</div>
          </div>
          <div className="bg-primary-50 rounded-lg p-6">
            <div className="text-3xl font-bold text-primary-600 mb-2">24/7</div>
            <div className="text-gray-700">Expert Support</div>
          </div>
        </div>*/}
      </div>
    </section>
  );
}
